import React from 'react';

import PrimaryItems from 'components/nav/authenticated/PrimaryItems';

class AuthenticatedNavBottom extends React.Component {
  render() {
    return (
      <nav className="aa-navbar-second navbar navbar-inverse hidden-xs">
        <div className="container-fluid">
          <div className="row">
            <PrimaryItems />
          </div>
        </div>
      </nav>
    );
  }
}

export default AuthenticatedNavBottom;
